import React, { FC, useCallback } from 'react';
import { FormProvider, SubmitHandler } from 'react-hook-form';

import { IDemoAccountResponse, IRegisterDemoAccountParams } from '@webtrader/core/api/experienceDemo';
import { IExperienceFormInputs, useExperienceForm } from '@webtrader/core/hooks/experienceDemo/useExperienceDemoForm';
import { experienceDemoCreationService } from '@webtrader/core/services/experienceDemo/experienceDemoCreation';

import BaseRegisterAccountForm from '../components/Forms/BaseRegisterAccountForm';

interface IExperienceDemoCreationProps {
  onSuccess: (result: IDemoAccountResponse) => void;
}

const ExperienceDemoCreation: FC<IExperienceDemoCreationProps> = ({ onSuccess }) => {
  const formMethods = useExperienceForm();
  const { handleSubmit, setError } = formMethods;

  const onSubmit = useCallback<SubmitHandler<IExperienceFormInputs>>(async () => {
    const params: IRegisterDemoAccountParams = {
      email: formMethods.getValues().email?.toLowerCase() ?? ''
    };

    const { result, success, message } = await experienceDemoCreationService.submitForm(params);
    if (!success) {
      setError(
        'email',
        {
          type: 'apiError',
          message: message
        },
        { shouldFocus: true }
      );
      return;
    }
    if (result) {
      onSuccess(result);
    }
  }, [formMethods, onSuccess, setError]);

  return (
    <>
      <FormProvider {...formMethods}>
        <BaseRegisterAccountForm onSubmit={handleSubmit(onSubmit)} />
      </FormProvider>
    </>
  );
};

export default ExperienceDemoCreation;
